import React from 'react'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

import MakeCollapse from './MakeCollapse'

interface CompatibilityProps {
  compatibilities: ListingModel['compatibilities']
  isShowFirstItem?: boolean
}

const Compatibility: RFC<CompatibilityProps> = ({
  compatibilities,
  isShowFirstItem = false
}) => {
  return (
    <Stack direction="column" spacing={1}>
      {compatibilities?.map((compatibility, index) => {
        const isFirstItem = index === 0
        const isClickDisabled = !compatibility.vehicle_details?.length
        const isOpen = isFirstItem && !isClickDisabled

        return (
          <MakeCollapse
            key={compatibility.make}
            title={compatibility.make}
            {...(isShowFirstItem && { open: isOpen })}
            isClickDisabled={isClickDisabled}
          >
            {compatibility.vehicle_details?.map((item) => (
              <Text
                key={item.id}
                variant="subtitle1"
                component="p"
                sx={{ mb: IS_NATIVE_APP ? 0 : 0.5 }}
              >
                {item.title}
              </Text>
            ))}
          </MakeCollapse>
        )
      })}
    </Stack>
  )
}

export default Compatibility
